export default __webpack_public_path__ + "static/media/calendar.feb77586.png";